import * as React from 'react'

import SvgIcon, { SvgIconProps } from '../../SvgIcon'

const PayPalIcon: React.FC<React.PropsWithChildren<SvgIconProps>> = (props) => (
  <SvgIcon viewBox="0 0 504 504" {...props}>
    <path
      d="M389.6 221.2h-27.2c-1.6 0-3.2 1.6-4 3.2l-11.2 70.4c0 1.6.8 2.4 2.4 2.4H364c1.6 0 2.4-.8 2.4-2.4l3.2-20c0-1.6 1.6-3.2 4-3.2h8.8c18.4 0 28.8-8.8 31.2-26.4 1.6-7.2 0-13.6-3.2-17.6-4.8-4-12-6.4-20.8-6.4m3.2 26.4c-1.6 9.6-8.8 9.6-16 9.6H372l3.2-18.4c0-.8.8-1.6 2.4-1.6h1.6c4.8 0 9.6 0 12 3.2 1.6.8 1.6 3.2 1.6 7.2"
      fill="#139ad6"
    />
    <path
      d="M193.6 221.2h-27.2c-1.6 0-3.2 1.6-4 3.2l-11.2 70.4c0 1.6.8 2.4 2.4 2.4h12.8c1.6 0 3.2-1.6 4-3.2l3.2-19.2c0-1.6 1.6-3.2 4-3.2h8.8c18.4 0 28.8-8.8 31.2-26.4 1.6-7.2 0-13.6-3.2-17.6-4.8-4-11.2-6.4-20.8-6.4m3.2 26.4c-1.6 9.6-8.8 9.6-16 9.6h-4l3.2-18.4c0-.8.8-1.6 2.4-1.6h1.6c4.8 0 9.6 0 12 3.2.8.8 1.6 3.2.8 7.2m79.2-.8h-12.8c-.8 0-2.4.8-2.4 1.6l-.8 4-.8-1.6c-3.2-4-8.8-5.6-15.2-5.6-14.4 0-27.2 11.2-29.6 26.4-1.6 8 .8 15.2 4.8 20s9.6 6.4 16.8 6.4c12 0 18.4-7.2 18.4-7.2l-.8 4c0 1.6.8 2.4 2.4 2.4h12c1.6 0 3.2-1.6 4-3.2l7.2-44.8c-.8-.8-2.4-2.4-3.2-2.4m-18.4 25.6c-1.6 7.2-7.2 12.8-15.2 12.8-4 0-7.2-1.6-8.8-3.2-1.6-2.4-2.4-5.6-2.4-9.6.8-7.2 7.2-12.8 14.4-12.8 4 0 6.4 1.6 8.8 3.2 2.4 2.4 3.2 6.4 3.2 9.6"
      fill="#263b80"
    />
    <path
      d="M471.2 246.8h-12.8c-.8 0-2.4.8-2.4 1.6l-.8 4-.8-1.6c-3.2-4-8.8-5.6-15.2-5.6-14.4 0-27.2 11.2-29.6 26.4-1.6 8 .8 15.2 4.8 20s9.6 6.4 16.8 6.4c12 0 18.4-7.2 18.4-7.2l-.8 4c0 1.6.8 2.4 2.4 2.4h12c1.6 0 3.2-1.6 4-3.2l7.2-44.8c-.8-.8-1.6-2.4-3.2-2.4m-18.4 25.6c-1.6 7.2-7.2 12.8-15.2 12.8-4 0-7.2-1.6-8.8-3.2-1.6-2.4-2.4-5.6-2.4-9.6.8-7.2 7.2-12.8 14.4-12.8 4 0 6.4 1.6 8.8 3.2 3.2 2.4 4 6.4 3.2 9.6"
      fill="#139ad6"
    />
    <path
      d="M345.6 246.8H332c-1.6 0-2.4.8-3.2 1.6l-17.6 27.2-8-25.6c-.8-1.6-1.6-2.4-4-2.4h-12.8c-1.6 0-2.4 1.6-2.4 3.2l14.4 42.4-13.6 19.2c-.8 1.6 0 4 1.6 4h12.8c1.6 0 2.4-.8 3.2-1.6l44-63.2c2.4-2.4.8-4.8-.8-4.8"
      fill="#263b80"
    />
    <path
      d="M486.4 223.6l-11.2 72c0 1.6.8 2.4 2.4 2.4h11.2c1.6 0 3.2-1.6 4-3.2l11.2-70.4c0-1.6-.8-2.4-2.4-2.4h-12.8c-.8-.8-1.6 0-2.4 1.6"
      fill="#139ad6"
    />
    <path
      d="M92 197.2c-5.6-6.4-16-9.6-30.4-9.6h-40c-2.4 0-4.8 2.4-5.6 4.8L0 297.2c0 2.4 1.6 4 3.2 4H28l6.4-39.2v1.6c.8-2.4 3.2-4.8 5.6-4.8h12c23.2 0 40.8-9.6 46.4-36v-2.4c-.8 0-.8 0 0 0 .8-10.4-.8-16.8-6.4-23.2"
      fill="#263b80"
    />
    <path
      d="M97.6 220.4v2.4c-5.6 27.2-23.2 36-46.4 36h-12c-2.4 0-4.8 2.4-5.6 4.8l-8 48.8c0 1.6.8 3.2 3.2 3.2h20.8c2.4 0 4.8-1.6 4.8-4v-.8l4-24.8v-1.6c0-2.4 2.4-4 4.8-4h3.2c20 0 36-8 40-32 1.6-9.6.8-18.4-4-24-.8-1.6-2.4-3.2-4.8-4"
      fill="#139ad6"
    />
    <path
      d="M92 218c-.8 0-1.6-.8-2.4-.8s-1.6 0-2.4-.8c-3.2-.8-6.4-.8-10.4-.8H45.6c-.8 0-1.6 0-2.4.8-1.6.8-2.4 2.4-2.4 4L34.4 262v1.6c.8-2.4 3.2-4.8 5.6-4.8h12c23.2 0 40.8-9.6 46.4-36 0-.8 0-1.6.8-2.4-1.6-.8-2.4-1.6-4-1.6-2.4-.8-2.4-.8-3.2-.8"
      fill="#232c65"
    />
  </SvgIcon>
)

export default PayPalIcon
